import {compileDictionary} from "./utils/compileDectionary";
import {nodeNameToFactoryId} from "./utils/nodeNameToFactoryId";

export function compileExports(
  nodeExports: Array<string>
): string {
  return `module.exports = ${compileDictionary(nodeExports
    .reduce((result, nodeName) => {
      const factoryId = nodeNameToFactoryId(nodeName);
      result[factoryId] = factoryId;
      return result;
    }, {} as Record<string, string>))}`;
}
